<template>
  <div
    @wheel.stop
    class=" fixed inset-0 z-20 flex flex-col h-full overflow-hidden"
    :class="{ 'bg-white text-gray-gray': light, 'bg-deepWater': !light }"
  >
    <div class="container flex flex-col h-full mx-auto">
      <div
        class="flex justify-end flex-none p-4 pr-0 mr-4"
        :class="{ 'bg-white text-gray-gray': light, 'bg-deepWater': !light }"
      >
        <div
          @click="handleClose"
          class="text-brand"
          :class="{ 'text-primary': light }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="w-8 h-8 cursor-pointer"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      </div>
      <app-scrollable-box class="flex-1 px-4 mb-6">
        <slot />
      </app-scrollable-box>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: Function,
    light: Boolean
  },
  methods: {
    handleClose() {
      this.close ? this.close() : this.$router.go(-1);
    }
  }
};
</script>
